import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHandshakeAngle, faListCheck} from '@fortawesome/free-solid-svg-icons';
import DashboardShell from './DashboardShell';
import {useDashboardData} from './useDashboardData';
import {StatTile, DonutBreakdown, CategoryBarChart} from '../../../components/charts';

type PartnerData = {
    active_partners: number;
    total_partner_services: number;
    services_by_status: {name: string; value: number}[];
    top_service_categories: {name: string; value: number}[];
};

/** Partner / Facility Performance (P3) - execution_strategy_activity_tracker.md
 * Phase 4.6. The thinnest area of the frontend per the original audit
 * (~30% built) - leans entirely on data that already exists. */
const PartnerPerformanceDashboard: React.FC = () => {
    const {data, loading, error} = useDashboardData<PartnerData>('/admin-dashboard/dashboards/partner-performance/');

    return (
        <DashboardShell
            title="Partner & Facility Performance"
            subtitle="Active partners and where their services concentrate"
            loading={loading}
            error={error}
        >
            {data && (
                <>
                    <div className="row g-3 mb-4">
                        <div className="col-md-6">
                            <StatTile icon={faHandshakeAngle} label="Active Partners" value={data.active_partners} color="#0ab39c"/>
                        </div>
                        <div className="col-md-6">
                            <StatTile icon={faListCheck} label="Total Partner Services" value={data.total_partner_services} color="#405189"/>
                        </div>
                    </div>

                    <div className="row g-3">
                        <div className="col-lg-5">
                            <div className="uz-panel h-100">
                                <div className="uz-panel-header"><span className="uz-section-title">Services by Status</span></div>
                                <div className="uz-panel-body">
                                    <DonutBreakdown data={data.services_by_status}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="uz-panel h-100">
                                <div className="uz-panel-header"><span className="uz-section-title">Top Service Categories</span></div>
                                <div className="uz-panel-body">
                                    <CategoryBarChart data={data.top_service_categories} xKey="name" yKey="value" colorByCategory/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </DashboardShell>
    );
};

export default PartnerPerformanceDashboard;
